<template>
  <div class="no-products">
    <h1 class="main-title">There is no images for this search criteria</h1>
    <button
        @click="resetFilters"
        class="filters__clear activeClass">
      Clear Filters
    </button>
  </div>
</template>
<script setup lang="ts">
import {useProductStore} from "../../store/product.ts";

const {resetFilters} = useProductStore();
</script>